import { render, staticRenderFns } from "./TcfdDataTable.vue?vue&type=template&id=b71a2560"
import script from "./TcfdDataTable.vue?vue&type=script&lang=js"
export * from "./TcfdDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports